export default __webpack_public_path__ + "static/media/161675df1f8156cbe6165cb7574218dc.png";